import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { store } from 'Store';
import { clearFields } from "Store/LoginInfoSlice";
import { http } from "Utils";
import { httpLogin } from "Utils/httpLogin";
import useBroadcast from 'Utils/useBroadcast';
import { Button, Image } from 'react-bootstrap';
import SubMenu from "Components/Navigation/LeftNavigation/LeftNavigationSubMenu.js";
import ListItem from "Components/Navigation/LeftNavigation/LeftNavigationListItem.js";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { TOP_NAV_ITEMS_AS_LEFT_NAV, USER_PROFILE_ITEMS_AS_LEFT_NAV, HELP_ABOUT_AS_LEFT_NAV } from '../TopNavigation/TopNavigationData2';
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling'
import Logo2 from "Images/PSOPPC-logo -color2.png"
import Avatar from 'Images/Avatar.png'
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';

const PublicLeftNavigation = ({ showCollapsedSideNav, closeCollapsedSideNav }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginInfo = useSelector(state => state.loginInfo);
  const loginState = store.getState().loginInfo;
  const [navMenu, setNavMenu] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState({
    title: "",
    isOpen: false
  });
  const { message, sendMessage } = useBroadcast("auth_channel");

  /**
   * process the navigation menu data for rendering
   * @param {*} menuList 
   *  element
   * {displayOrder: 1
      isActive: 1
      isPubAccess: 0
      menuId: 1
      menuLink: "/psoppc-web/dashboard"
      menuName1: "Dashboard"
      menuName2: null
      roleAhrqManager: 1
      roleAhrqUser: 1
      roleLevel1: 0
      roleLevel2: 1
      rolePsoAdmin: 1
      rolePsoLevel3: 1
      rolePsoppcAdmin: 1
      rolePsoppcManager: 1
      roleVendorLevel3: 1
      }
   */
  const processNavigationMenu = (menuList) => {
    let len = menuList.length;
    let i = 0;
    let navigationMenu = [];

    while (i < len) {
      let menuName1 = menuList[i].menuName1;
      // dropdown
      if (menuList[i].menuName2) {
        let subMenu = {};
        let subList = [];

        while (menuName1 == menuList[i]?.menuName1) {
          subList.push(menuList[i]);
          i++;
        }
        subMenu.subList = subList;
        subMenu.title = menuName1;
        navigationMenu.push(subMenu);
        // link item
      } else {
        navigationMenu.push(menuList[i]);
        i++;
      }
    }
    //console.log("process nav menu", navigationMenu);
    setNavMenu(navigationMenu);
  }

  const getSelectedMenu = (menu) => {
    // "isOPen" may not be needed, will remove it
    setSelectedMenu({
      title: menu,
      isOpen: false
    });
  }

  // api to get batch file info
  const getUserNavigationMenu = async (filter) => {

    var url = loginState.token ? '/api/navigation/getUserNavigationMenu' : '/api/navigation/getPublicNavigationMenu';
    //var url = '/api/navigation/getPublicNavigationMenu';
    return http.post(url, {}, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    }).then((res) => {
      //console.log("getUserNavigationMenu", res);
      if (res.status !== 1) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: res.globalErrorMessageList,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        });
      }

      processNavigationMenu(res.data);
    }).catch((error) => {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  const handleLogin = async () => {

    navigate(PATHS.public['Sign In']);
  }

  const handleLogout = async () => {
    const res = await logout();

    navigate(PATHS.public['Sign In']);
  }

  // api to logout
  const logout = async () => {

    for (let i = 0; i <= sessionStorage.getItem("validateAccessInterval"); i++) {
      window.clearInterval(i);
    }

    const res = httpLogin.post('/auth/logout', {}, {
      headers: {
        "Authorization": "Bearer " + loginInfo.token
      }
    }).then(() => {
      dispatch(clearFields(loginInfo.initialState));
      sendMessage({
        token: "Bearer " + loginInfo.token,
        status: STATUSES.LOG_OUT.text
      });
    }).catch(function (error) {
      return error.response;
    });

    return res;
  }

  useEffect(() => {
    getUserNavigationMenu();
  }, []);

  return (
    <Offcanvas show={showCollapsedSideNav} onHide={closeCollapsedSideNav} onHidden={closeCollapsedSideNav} responsive="lg" className="leftNavCol">
      <Offcanvas.Header >
        {/** logo */}
        <Offcanvas.Title>
          <Image className="ms-4 sitelogo" alt="PSOP Privary Protection Center Logo" src={Logo2} />
        </Offcanvas.Title>
        <Button type="button" title="Close Menu Button" className="btn-close" onClick={closeCollapsedSideNav}></Button>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-block p-0 " id="menuBg">
        {/** user info if there is */}
        {loginState.token ?
          <>
            <div className="respProfile d-lg-none">
              <Image alt="Avatar" src={Avatar} className="mb-2" />
              <div className="">
                <span className=''>{loginInfo.firstName}&nbsp;{loginInfo.lastName}</span>
                <br />
                <span className=''>{loginInfo.username}</span>
              </div>
            </div>
            <ul class="navbar-nav me-auto mb-4 mb-lg-0 d-lg-none ps-3 pe-3" id="sideNav">
              {USER_PROFILE_ITEMS_AS_LEFT_NAV.map((item, index) => {
                if (item.type === "listItem") {
                  return <ListItem key={"topRespNav" + index} listItemTitle={item.menuName1} listItemLink={item.menuLink} showCollapsedSideNav={showCollapsedSideNav} closeCollapsedSideNav={closeCollapsedSideNav}></ListItem>
                }
                if (item.type === "subMenu") {
                  return <SubMenu key={"topRespNav" + index} subMenuButtonTitle={item.title} subMenuId={item.title} subMenuItems={item.subList} selected={selectedMenu} showCollapsedSideNav={showCollapsedSideNav} closeCollapsedSideNav={closeCollapsedSideNav}></SubMenu>
                }
              })}
            </ul>
          </>
          : null}
        <h2 className="menuTitle d-lg-none">Pages</h2>
        {/** display top nav */}
        <ul class="navbar-nav me-auto mb-lg-0 d-lg-none ps-3 pe-3" id="sideNav">
          {TOP_NAV_ITEMS_AS_LEFT_NAV.map((item, index) => {
            if (item.type === "listItem") {
              return <ListItem key={"topRespNav" + index} listItemTitle={item.menuName1} listItemLink={item.menuLink} showCollapsedSideNav={showCollapsedSideNav} closeCollapsedSideNav={closeCollapsedSideNav}></ListItem>
            }
            if (item.type === "subMenu") {
              return <SubMenu key={"topRespNav" + index} subMenuButtonTitle={item.title} subMenuId={item.title} subMenuItems={item.subList} selected={selectedMenu} showCollapsedSideNav={showCollapsedSideNav} closeCollapsedSideNav={closeCollapsedSideNav}></SubMenu>
            }
          })}
        </ul>
        <ul class="navbar-nav me-auto mb-3 mb-lg-0 d-lg-none ps-3 pe-3" id="sideNav">
          {HELP_ABOUT_AS_LEFT_NAV.map((item, index) => {
            return (
              <ListItem key={"sideNav" + index} listItemTitle={item.menuName1} listItemLink={item.menuLink} showCollapsedSideNav={showCollapsedSideNav} closeCollapsedSideNav={closeCollapsedSideNav}></ListItem>
            )
          })}
        </ul>
        {/** display left nav if the user login */}
        {loginState.token ?
          <>
            <h2 className="menuTitle d-lg-none">Tools</h2>
            <ul class="navbar-nav d-lg-none me-auto mb-2 mb-lg-0 ps-3 pe-3" id="sideNav">
              {navMenu.map((item, index) => {
                if (Array.isArray(item?.subList)) {
                  return (
                    <SubMenu key={"sideNav" + index} subMenuButtonTitle={item.title} subMenuId={item.title} subMenuItems={item.subList} getSelectedMenu={getSelectedMenu} selected={selectedMenu} setSelected={setSelectedMenu} showCollapsedSideNav={showCollapsedSideNav} closeCollapsedSideNav={closeCollapsedSideNav}></SubMenu>
                  )
                } else {
                  return (
                    <ListItem key={"sideNav" + index} listItemTitle={item.menuName1} listItemLink={item.menuLink} showCollapsedSideNav={showCollapsedSideNav} closeCollapsedSideNav={closeCollapsedSideNav}></ListItem>
                  )
                }
              })}
            </ul>
          </> : null}
        {/** sign in/out */}
        {loginState.token ?
          <div className="respProfile d-lg-none" onClick={handleLogout}>
            <FontAwesomeIcon icon={faArrowRightFromBracket} /> Sign Out
          </div> : <div className="respProfile d-lg-none" onClick={handleLogin}>
            <FontAwesomeIcon icon={faArrowRightFromBracket} /> Sign In
          </div>}
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default PublicLeftNavigation;